<template>
  <div>
    <wc-page-title title='Change Password'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='6'>
          <wc-data-box
            hideToolbar
            hideCancel
            saveText='Change Password'
            :disableButtons='!isFormValid'
            :loadingButtons='isLoading'
            @save='submitNewPassword'
          >
            <v-card-text>
              When you change your password, you will be required to re-login.<br>
              Your new password must be at least 8 characters long, and contain at least one number and one letter.
              <v-form v-model='isFormValid'>
                <v-text-field label='New Password' v-model='newPassword' :rules='[rules.required, rules.min8long, rules.containLetter, rules.containNumber]' type='password'></v-text-field>
                <v-text-field label='Confirm Password' v-model='confrimPassword' :rules='[rules.required]' type='password'></v-text-field>
              </v-form>
              <span v-if='passwordMismatch' class='error--text'>Your passwords don't match</span>
            </v-card-text>
            <v-card-actions>
              <v-btn
                depressed
                color='error'
                :disabled='!isFormValid || passwordMismatch'
                :loading='isLoading'
                @click='submitNewPassword'
              >Change Password</v-btn>
            </v-card-actions>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <!-- Success Dialog -->
    <wc-dialog :showDialog='showSuccessDialog' title='Success' saveText='Logout' hideCancel @save='logout'>
      <template v-slot:dialog-text>
        Your password has been successfully changed. You will now be required to re-login with your new password
      </template>
    </wc-dialog>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'
export default {
  name: 'change-password',
  mixins: [formRules],
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showSuccessDialog: false,
    newPassword: '',
    confrimPassword: ''
  }),
  computed: {
    passwordMismatch () {
      return this.newPassword !== this.confrimPassword
    },
    disableSubmit () {
      return !this.isFormValid || this.passwordMismatch
    }
  },
  methods: {
    async submitNewPassword () {
      this.isLoading = true
      let resp = await this.$axios.post(this.$endpoints.changePassword, { password: this.newPassword })
      if (resp) {
        this.showSuccessDialog = true
      }
    },
    logout () {
      this.$router.push({ name: 'Logout' })
      window.location.reload()
    }

  }
}
</script>
